<template>
  <div class="ma-4">
    <v-alert v-if="error" type="error">{{ error }}</v-alert>

    <v-card class="pa-4" outlined>
      <b>Receita de Locação</b>
      <v-autocomplete
        v-model="selectedCategories.location"
        :disabled="loadingSave"
        :items="categories"
        :loading="loading"
        class="mt-4"
        item-text="descricao"
        item-value="codigo"
        label="Selecione uma categoria"
        hide-details
        outlined
      >
        <template v-slot:item="{ item }">
          <v-chip small label style="width: 60px" class="justify-center mr-2">
            {{ item.codigo }}
          </v-chip>

          {{ item.descricao }}
        </template>
      </v-autocomplete>

      <div class="d-flex justify-end mt-3">
        <v-btn color="primary" @click="save">Salvar</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import SETTINGS from '@/services/settings'

export default {
  data() {
    return {
      error: null,
      loading: false,
      loadingSave: false,
      selectedCategories: {
        location: null,
      },
      loading: false,
      categories: [],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      try {
        this.loading = true
        await Promise.all([this.getOmieCategories(), this.getCategories()])
      } catch (error) {
        this.error = error.message || 'Erro ao carregar categorias'
      } finally {
        this.loading = false
      }
    },
    async getCategories() {
      const r = await SETTINGS.categories.getAll()
      this.selectedCategories.location = r.location
    },
    async getOmieCategories() {
      const r = await SETTINGS.categories.omie()
      this.categories = r.categories.filter(c => {
        if (c.nao_exibir == 'S') return false
        if (c.conta_receita !== 'S') return false
        return true
      })
    },
    async save() {
      try {
        this.loadingSave = true
        this.error = null
        await SETTINGS.categories.set(this.selectedCategories)
        this.loadingSave = false
      } catch (error) {
        this.error = error.message || 'Erro ao salvar categorias'
      } finally {
        this.loadingSave = false
      }
    },
  },
}
</script>
